'use client';

import React from 'react';
// import { usePathname } from 'next/navigation';
import Link from 'next/link';
import clsx from 'clsx';
import { Icons } from '@shared/ui';
import { useNavigationContext } from './useNavigation';

interface MenuItemProps extends DetailMenuNodes {
    children: React.ReactNode;
    showOpenInNewTab?: boolean;
    levelIndex?: number;
}

export const MenuItem: React.FC<MenuItemProps> = (props) => {
    const { children, next, type, url, levelIndex = 0, value } = props;

    const { state, actions } = useNavigationContext();

    function onExpandMenuGroup() {
        if (!next) {
            return;
        }

        actions.handleNavigationGroupOpen(true, levelIndex, next, value);
    }

    const LinkComponent = type === 'url' ? 'a' : Link;

    return (
        <li
            className={clsx('menu-item', {
                'menu-item--active': state.currentNode[levelIndex] === value,
            })}
        >
            {type === 'none' ? (
                <span className="menu-item-text menu-item-text--none">{children}</span>
            ) : (
                <LinkComponent
                    href={url || '/'}
                    target={state.openInNewTab ? '_blank' : undefined}
                    rel={state.openInNewTab ? 'noopener noreferrer' : undefined}
                    className="menu-item-text"
                >
                    {children}
                </LinkComponent>
            )}
            {next && next.length > 0 && (
                <button
                    type="button"
                    className="menu-item-arrow"
                    onClick={onExpandMenuGroup}
                >
                    <Icons.csr.CaretDown size="1em" weight="bold" />
                </button>
            )}
        </li>
    );
};
